import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Contexts/AuthContext";
import { ApplicationFormProvider } from "./Contexts/ApplicationFormContext";
import { RegistrationConfigProvider } from './Contexts/RegistrationConfigContext';
import "./Services/firebase-config"; // Ensure Firebase is initialized
import { getAnalytics } from "firebase/analytics";
import { initializeClarity } from "./Services/clarity-config"; // Initialize Clarity

const root = ReactDOM.createRoot(document.getElementById("root"));

// Initialize Microsoft Clarity for analytics
initializeClarity();

root.render(
  <React.StrictMode>
    <RegistrationConfigProvider>
      <AuthProvider>
        {/* <ApplicationFormProvider> */}
        <App />
        {/* </ApplicationFormProvider> */}
      </AuthProvider>
    </RegistrationConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
